/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-close': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<defs><path pid="0" d="M8 4.667c-.367 0-.667.3-.667.666v2h-2c-.366 0-.666.3-.666.667 0 .367.3.667.666.667h2v2c0 .366.3.666.667.666.367 0 .667-.3.667-.666v-2h2c.366 0 .666-.3.666-.667 0-.367-.3-.667-.666-.667h-2v-2c0-.366-.3-.666-.667-.666zm0-3.334A6.67 6.67 0 001.333 8 6.67 6.67 0 008 14.667 6.67 6.67 0 0014.667 8 6.67 6.67 0 008 1.333zm0 12A5.34 5.34 0 012.667 8 5.34 5.34 0 018 2.667 5.34 5.34 0 0113.333 8 5.34 5.34 0 018 13.333z" id="svgicon_alert-close_a"/></defs><use _fill="#F93457" transform="rotate(-45 6.293 8.707)" xlink:href="#svgicon_alert-close_a" fill-rule="evenodd"/>'
  }
})
